import {
  SUBMIT_ANSWER_SUCCESS,
  SUBMIT_ANSWER_PENDING,
  SUBMIT_ANSWER_FAIL,
  REMOVE_ANSWER,
  RESET_ANSWERS,
} from '~/constants/action_types';
import MESSAGE from '~/constants/question_types';

// Normalize answerInput and send to reducer to be stored in app state.
export const submitAnswer = (question, answerInput) => async (dispatch, getState, services) => {
  // Do not do anything for message type
  if (question.type === MESSAGE) return { isSuccess: true };

  const state = getState();
  const surveyCode = state.survey.surveyCode;
  const isPreview = state.survey.isPreview;
  const pendingAnswers = Object.keys(state.answers).reduce((total, key) => {
    return !state.answers[key].isSubmitted ? total + 1 : total;
  }, 0);

  // Tells the survey reducer how many answers are still pending to be saved.
  dispatch(submitAnswerPending(pendingAnswers + 1));

  const answer = {
    value: answerInput.value,
    comment: question.isCommentable ? answerInput.comment : '',
    isSkipped: answerInput.isSkipped || false,
  };

  // If we've de-selected all the answers for a required question
  // Don't post to the backend, but do mark this is an error
  if (answer.isSkipped && question.isRequired) {
    const err = new Error('Cannot skip a required question');
    dispatch(submitAnswerFail(question, answer, err));

    return {
      isSuccess: false,
      error: err,
      hideErrorMessage: true,
    };
  }

  try {
    // A preview or Shared Link survey never saves answers one at a time; they stay in front-end state.
    if (!isPreview && !state.survey.openSurvey) {
      const res = await services.submitAnswer(surveyCode, question.id, question.type, answer);

      if (!res.success) {
        const errorMessage = res.error || res;
        throw Error(`Error: ${errorMessage}`);
      }
    }

    if (question.controlConditions?.length > 0) {
      const currentIndex = state.questions.findIndex((q) => q.id === question.id);
      const hasDependentAnswer = state.questions.find((q, index) => {
        if (index <= currentIndex) return false;
        return !!state.answers[q.id];
      });
      if (hasDependentAnswer) {
        // have to do a hard reload here to re-init state
        // this is because of each question components is managing their state locally as of today
        // not able to reset their state from parent
        // REFACTOR: reset state directly to question components instead of page reload
        window.location.reload();
        return;
      }
    }

    dispatch(submitAnswerSuccess(question, answer));
    return { isSuccess: true };
  } catch (err) {
    // TODO: Instead of immediately dispatching the fail event, re-try X times first,
    // then upon failing X times, send the fail event.
    dispatch(submitAnswerFail(question, answer, err));

    return {
      isSuccess: false,
      error: err,
    };
  }
};

const submitAnswerSuccess = (question, answer) => ({
  type: SUBMIT_ANSWER_SUCCESS,
  questionId: question.id,
  questionType: question.type,
  value: answer.value,
  comment: answer.comment,
  isSkipped: answer.isSkipped,
  isSubmitted: true,
});

const submitAnswerPending = (pendingAnswers) => ({
  type: SUBMIT_ANSWER_PENDING,
  pendingAnswers,
});

const submitAnswerFail = (question, answer, error) => ({
  type: SUBMIT_ANSWER_FAIL,
  questionId: question.id,
  questionType: question.type,
  value: answer.value,
  comment: answer.comment,
  isSkipped: answer.isSkipped,
  isSubmitted: false,
  error,
});

// TODO: Integrate this with submitting skip to backend.
export const skipAnswer = (question) => {
  const answer = {
    isSkipped: true,
  };

  return {
    type: SUBMIT_ANSWER_SUCCESS,
    questionId: question.id,
    answer,
  };
};

// TODO: correspondingly save this update to backend
export const removeAnswer = (questionId) => ({
  type: REMOVE_ANSWER,
  questionId,
});

// TODO: remove all answers from backend
export const resetAnswers = () => ({
  type: RESET_ANSWERS,
});
